module.exports = "<a class=\"kuiLink\" href=\"#\">More info</a>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/guide/views/link/link.html
 ** module id = 737
 ** module chunks = 0
 **/